module.exports = __webpack_public_path__ + "static/mcaconsultants-logo-164d3171a737d6b75d257515b5beb672.jpg";